import { all } from 'redux-saga/effects'
import dashboardSagas from './components/Dashboard/sagas'
import companySagas from './components/Company/sagas'
import contactSagas from './components/Contact/sagas'
import contactsSagas from './components/Contacts/sagas'
import dealsSagas from './components/Deals/sagas'
import dealSagas from './components/Deal/sagas'
import proposalsSaga from './components/proposals/Proposals/sagas'
import proposalSaga from './components/proposals/Proposal/sagas'
import companiesSaga from './components/Companies/sagas'
import usersSaga from './components/Users/sagas'
import loginSagas from './components/Login/sagas'
import notificationsSagas from './components/Layout/Header/Notifications/sagas'
import calendarSagas from './components/Calendar/sagas'
import adminSagas from './components/Admin/Profile/sagas'
import listsSagas from './components/Lists/sagas'
import headerSagas from './components/Layout/Header/sagas'
import leadSagas from './components/Leads/Lead/sagas'
import settingsSagas from './components/settings/sagas'

export default function* rootSaga() {
  yield all([
    ...dashboardSagas,
    ...companySagas,
    ...contactSagas,
    ...contactsSagas,
    ...dealsSagas,
    ...dealSagas,
    ...proposalsSaga,
    ...proposalSaga,
    ...companiesSaga,
    ...usersSaga,
    ...loginSagas,
    ...notificationsSagas,
    ...calendarSagas,
    ...adminSagas,
    ...listsSagas,
    ...headerSagas,
    ...leadSagas,
    ...settingsSagas
  ])
}
